
































































































































































import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ALPage from '@/components/core/Page/ALPage.vue';
import FormBuilderPropertiesDrawer from '@/components/form-builder/FormBuilderPropertiesDrawer.vue';
import FormBuilderSectionToolbar from '@/components/form-builder/FormBuilderSectionToolbar.vue';
import FormBuilderTemplateDetailCard from '@/components/form-builder/FormBuilderTemplateDetailCard.vue';
import FormBuilderSectionFieldsDrawer from '@/components/form-builder/FormBuilderSectionFieldsDrawer.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import FormBuilderDetailStateCard from '@/components/form-builder/FormBuilderDetailStateCard.vue';

import {
  FormSection,
  FormTemplate,
  IFormFieldData,
  IFormSectionData,
  IFormTemplate,
  IFormTemplateData
} from '@/models';
import { ErrorManager } from '@/models/error';

import { deepEqual, diffDeep } from '@/utils/helpers';
import draggable from '@/mixins/draggable';
import mixins from '@/utils/mixins';

import { cloneDeep } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { AxiosError } from 'axios';

export default mixins(draggable).extend({
  name: 'FormBuilderDetailPage',
  components: {
    ErrorAlert,
    FormBuilderSectionToolbar,
    FormBuilderTemplateDetailCard,
    ALPage,
    FormBuilderPropertiesDrawer,
    FormBuilderSectionFieldsDrawer,
    ConfirmationDialog,
    FormBuilderDetailStateCard
  },

  provide(): { formBuilder: any } {
    //form builder component
    return {
      formBuilder: this
    };
  },

  data() {
    return {
      FormTemplate,
      templateLoading: false,
      loading: false,
      showErrorSnackbar: false,
      deleteDialog: false,

      errorMessage: '',
      detailErrorMessage: '',

      template: null as null | IFormTemplateData,

      tab: 0 as number,
      sectionIndex: -1,

      navDrawer: false,
      fieldDrawer: false,

      selectedSectionIndex: 0,
      selectedFieldIndex: -1
    };
  },

  computed: {
    ...mapGetters({
      getFormTemplateById: 'formTemplate/getFormTemplateById',
      getFormFieldById: 'formTemplate/getFormFieldById'
    }),

    formTemplateId(): number {
      return Number(this.$route.params.id);
    },

    formTemplate(): IFormTemplate {
      return this.getFormTemplateById(this.formTemplateId);
    }
  },

  watch: {
    tab: {
      handler(value) {
        this.scrollToSection(value);
        //set selected section
        this.selectedSectionIndex = value;
      }
    },

    navDrawer: {
      handler(val) {
        const isEqual = deepEqual(
          this.template,
          this.getFormTemplateById(this.formTemplateId)
        );

        if (isEqual) return;

        if (!val) {
          this.save();
        }
      }
    }
  },

  async mounted() {
    this.templateLoading = true;
    try {
      const template = await this.tryGetOrFetchFormTemplate();
      this.template = template;

      //default selection to first section
      this.selectedSectionIndex = 0;
    } catch (err) {
      const error = err as AxiosError;
      if (error.response) {
        if (error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        }
      }
      this.errorMessage = ErrorManager.extractApiError(error);
    } finally {
      this.templateLoading = false;
    }
  },

  methods: {
    ...mapActions({
      fetchFormTemplate: 'formTemplate/fetchFormTemplate',
      updateFormTemplate: 'formTemplate/updateFormTemplate',
      updateFormField: 'formTemplate/updateFormField',
      fetchFormField: 'formTemplate/fetchFormField'
    }),

    openRemoveSectionDialog(sectionIndex: number) {
      this.selectedSectionIndex = sectionIndex;
      this.deleteDialog = true;
    },

    closeDeleteDialog() {
      this.deleteDialog = false;
      this.selectedSectionIndex = -1;
    },

    openFieldTypeDrawer(index: number) {
      this.fieldDrawer = true;
      this.selectedFieldIndex = index;
    },

    //open the the field drawer on the newly created field automatically
    //occurs only if there was no error
    saveSelectedField() {
      this.save().then(() => {
        if (!this.showErrorSnackbar) {
          const selectedFieldIndex =
            (this.template!.sections as IFormSectionData[])[
              this.selectedSectionIndex!
            ].section_fields.length - 1;

          this.openDrawer(this.selectedSectionIndex, selectedFieldIndex);
        }
      });
    },

    openDrawer(sectionIndex: number, fieldIndex: number) {
      this.selectedFieldIndex = fieldIndex;
      this.selectedSectionIndex = sectionIndex;
      this.navDrawer = true;
    },

    scrollToSection(tab: number) {
      const element = document.getElementById(`section-${tab}`);
      const rect = element?.getBoundingClientRect();

      const containerElement = document.getElementById(`sections-container`);
      const containerRect = containerElement!.getBoundingClientRect();

      if (rect && containerElement && containerRect) {
        // Scroll to the position of the target element
        containerElement.scrollTo({
          top: element?.offsetTop,
          left: rect.left,
          behavior: 'smooth'
        });
      }
    },

    async tryGetOrFetchFormTemplate(): Promise<IFormTemplate> {
      if (!this.formTemplate) {
        await this.fetchFormTemplate(this.formTemplateId);
      }
      return this.formTemplate!;
    },

    async tryGetOrFetchFormFieldById(id: number) {
      if (!this.getFormFieldById(id)) {
        await this.fetchFormField(id);
      }
      return this.getFormFieldById(id)!;
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    removeSection() {
      this.template!.sections!.splice(this.selectedSectionIndex, 1);
      this.save().then(() => {
        this.closeDeleteDialog();
      });
    },

    addSection(index?: number) {
      const newLength = this.template!.sections!.length + 1;
      const section = new FormSection({
        title: `Section ${newLength}`,
        order: index ? index : newLength,
        section_fields: []
      });

      if (index) {
        this.template!.sections!.splice(index + 1, 0, section);
        this.reorderTemplateSections();
      } else {
        this.template!.sections!.push(section);
        this.save();
      }
    },

    reorderTemplateSections() {
      const reOrderedSections = this.template!.sections!.map((section, i) => {
        return {
          ...section,
          order: i
        };
      });

      this.template!.sections! = reOrderedSections;

      this.save();
    },

    async save() {
      this.loading = true;

      const formSubmissionDelta = diffDeep(
        this.template,
        this.getFormTemplateById(this.formTemplateId),
        true
      );

      //update changes to a formField Template
      try {
        for (let i = 0; i < formSubmissionDelta!.sections!.length; i++) {
          if (formSubmissionDelta!.sections![i].section_fields) {
            for (const field of formSubmissionDelta!.sections![i]
              .section_fields) {
              if (
                field.field_template &&
                typeof field.field_template == 'object'
              ) {
                const originalFormField = await this.tryGetOrFetchFormFieldById(
                  field.field_template.id!
                );

                const isEqual = deepEqual(
                  field.field_template,
                  originalFormField
                );
                //make sure api is only called when there is a change
                if (!isEqual) {
                  await this.updateFormField(field.field_template);
                }
                field.field_template = (field.field_template as IFormFieldData).id!;
              }
            }
          }
        }

        await this.updateFormTemplate(formSubmissionDelta);
      } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
        this.showErrorSnackbar = true;
        this.template = this.getFormTemplateById(this.formTemplateId);
      } finally {
        this.template = cloneDeep(this.formTemplate);
        this.loading = false;
      }
    }
  }
});
